// extracted by extract-css-chunks-webpack-plugin
module.exports = {"categoryGrid":"_1ru2yj","card":"J28g6v","mediumGrid":"_172VVC","smallGrid":"_3z55IW","noMargin":"ovM3Kl"};